var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E0F2FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F0F9FF",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0233 28.4607C19.254 30.7296 21.1703 32.5 23.5 32.5H32.5C34.8297 32.5 36.746 30.7296 36.9767 28.4607M19.0233 28.4607C19 28.9943 19 29.6501 19 30.5C19 32.3613 19 33.2919 19.2447 34.0451C19.7393 35.5673 20.9327 36.7607 22.4549 37.2553C23.2081 37.5 24.1387 37.5 26 37.5H30C31.8613 37.5 32.7919 37.5 33.5451 37.2553C35.0673 36.7607 36.2607 35.5673 36.7553 34.0451C37 33.2919 37 32.3613 37 30.5C37 29.6501 37 28.9943 36.9767 28.4607M19.0233 28.4607C19.051 27.8258 19.1117 27.3642 19.2447 26.9549C19.7393 25.4327 20.9327 24.2393 22.4549 23.7447C22.8726 23.609 23.3448 23.5486 24 23.5216M36.9767 28.4607C36.949 27.8258 36.8883 27.3642 36.7553 26.9549C36.2607 25.4327 35.0673 24.2393 33.5451 23.7447C33.1274 23.609 32.6552 23.5486 32 23.5216M32 23.5216V23.5C32 22.57 32 22.105 31.8978 21.7235C31.6204 20.6883 30.8117 19.8796 29.7765 19.6022C29.395 19.5 28.93 19.5 28 19.5C27.07 19.5 26.605 19.5 26.2235 19.6022C25.1883 19.8796 24.3796 20.6883 24.1022 21.7235C24 22.105 24 22.57 24 23.5V23.5216M32 23.5216C31.4736 23.5 30.8292 23.5 30 23.5H26C25.1708 23.5 24.5264 23.5 24 23.5216M28 31.5V33.5",
    stroke: "#0BA5EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveJobIcon);
export default __webpack_public_path__ + "static/media/active_jobIcon.bc920e0acada9e86bf15321506ae35f8.svg";
export { ForwardRef as ReactComponent };